import { render, staticRenderFns } from "./AcceptAmount.vue?vue&type=template&id=043e71a0&scoped=true&"
import script from "./AcceptAmount.vue?vue&type=script&lang=js&"
export * from "./AcceptAmount.vue?vue&type=script&lang=js&"
import style0 from "./AcceptAmount.vue?vue&type=style&index=0&id=043e71a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043e71a0",
  null
  
)

export default component.exports